<div class="login_section">
	<app-auth-brand-panel variant="login"></app-auth-brand-panel>

	<!-- Form panel -->
	<main class="form_section">
		<div class="form_card">
			<header class="form_header">
				<h2>Welcome back</h2>
				<p>Log in to your SuperSee workspace</p>
			</header>

			<form [formGroup]="loginForm" (ngSubmit)="userLogin()" novalidate>
				<div class="field">
					<label for="login-email">Email</label>
					<input #emailInput id="login-email" class="browser-default" type="text" formControlName="username"
						placeholder="you@company.com" autocomplete="username" inputmode="email" autocapitalize="none"
						spellcheck="false" aria-describedby="login-email-error">
					<p class="field_error" id="login-email-error" role="alert"
						*ngIf="loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched">
						Please enter your email</p>
				</div>

				<div class="field">
					<div class="label_row">
						<label for="login-password">Password</label>
						<a class="forgot_link" routerLink="/forgot-password">Forgot password?</a>
					</div>
					<div class="password_wrap">
						<input id="login-password" class="browser-default" [type]="hide ? 'password' : 'text'"
							formControlName="password" placeholder="Enter your password"
							autocomplete="current-password" aria-describedby="login-password-error">
						<button type="button" class="passBtn" (click)="hide = !hide"
							[attr.aria-label]="hide ? 'Show password' : 'Hide password'" [attr.aria-pressed]="!hide">
							<mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
						</button>
					</div>
					<p class="field_error" id="login-password-error" role="alert"
						*ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched">
						Please enter your password</p>
				</div>

				<p class="form_error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>

				<button type="submit" class="signInBtn" [disabled]="isloading">
					<span *ngIf="!isloading">Log in</span>
					<span *ngIf="isloading" class="btn_loading"><span class="btn_spinner"></span>Logging in…</span>
				</button>

				<div class="separator"><span>or</span></div>

				<div class="google-signin-container">
					<app-google-signin></app-google-signin>
				</div>
			</form>

			<p class="signup_line">New to SuperSee? <a routerLink="/signup">Start your 14-day free trial</a></p>
			<p class="help_line">Trouble logging in?
				<a href="https://wa.me/916354719703?text=Hi%2C%20I%20need%20help%20logging%20in%20to%20SuperSee"
					target="_blank" rel="noopener">Chat on WhatsApp</a></p>
		</div>
	</main>
</div>

<app-loader *ngIf="loading"></app-loader>
